import React, { useState } from 'react';
import { useSelector, useDispatch, useStore } from 'react-redux';
import { Button } from '@mui/material';
import ModalAlert from '../modalAlert';
import { updateTempState } from '../../../actions/temp';
import { useRouter } from '../../../hooks';
import { apiCallWizard } from '../../../actions/wizards';
import { getAllData } from '../../wizards/functions';

export default function Settings() {
  const dispatch = useDispatch();
  const router = useRouter();
  const reduxStore = useStore();
  const alertPopUp = useSelector(state => state.temp.alertPopUp);
  const onModalClose = useSelector(state => state.temp.onClose);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    if (onModalClose) onModalClose();
    dispatch(updateTempState.updateTempStateAction({ alertPopUp: null }));
  };

  // Custom handler for Submit button — triggers apiCalls if present, then navigates
  const handleSubmit = async () => {
    const apiCalls = alertPopUp?.apiCalls;
    const redirectUrl = alertPopUp?.redirectUrl || '/thank-you';

    if (apiCalls && apiCalls.length > 0) {
      try {
        setIsSubmitting(true);
        const storeState = reduxStore.getState();
        await getAllData(
          apiCalls,
          apiCallWizard.apiCallWizardAction,
          dispatch,
          storeState,
        );
      } catch (error) {
        console.error('Error executing popup apiCalls:', error);
      } finally {
        setIsSubmitting(false);
      }
    }

    dispatch(updateTempState.updateTempStateAction({ alertPopUp: null }));
    router.push(redirectUrl);
  };

  const validUrl =
    !alertPopUp?.onlyShowOnUrl || router?.pathname?.includes(alertPopUp?.onlyShowOnUrl);

  return (
    <div>
      {alertPopUp && alertPopUp?.content && validUrl && (
        <ModalAlert
          open={alertPopUp}
          title={alertPopUp?.title}
          content={alertPopUp?.content}
          dismissiveAction={{
            label: alertPopUp?.dismissiveAction || 'Submit',
            onClick: handleSubmit,
            disabled: isSubmitting,
          }}
          confirmingAction={alertPopUp?.confirmingAction}
          setCloseAsDismissiveAction={alertPopUp?.setCloseAsDismissiveAction}
          maxWidth={alertPopUp?.maxWidth}
          onClose={() => handleClose()}
          isBlocking={alertPopUp?.blockEscape}
          allowFullscreen={alertPopUp?.allowFullscreen}
          hideXButton={alertPopUp?.hideXButton}
        />
      )}
    </div>
  );
}
